module.exports = __webpack_public_path__ + "img/icecream.8aa548f3.svg";